import { useEffect, useState } from "react";
import { Form, InputGroup, Table } from "react-bootstrap";
import pLimit from "p-limit";
import {
  fetchTranslations,
  translate,
  updateTranslations,
} from "../context/functions/AdminFunction";
import { toast } from "react-toastify";
import Loading from "../components/loader/Loading";
import { haveValue } from "../utils/common";
import { MdInfoOutline } from "react-icons/md";

import { GoogleGenerativeAI } from "@google/generative-ai";
const genAI = new GoogleGenerativeAI('AIzaSyDqUt53Z5JTEGNoEazJPLm8pPD0tEvaMNo');

const TranslationList = (props) => {

  const [translations, setTranslations] = useState([]);
  const [loading, setLoading] = useState(false);

  const model = genAI.getGenerativeModel(
    { model: "gemini-2.5-pro" },
    { apiVersion: "v1beta" }
  );

  useEffect(() => {
    const getTranslationsFunc = async () => {
      setLoading(true);
      try {
        const response = await fetchTranslations();
        let data = response?.data;
        if (data && data?.success_res?.data) {
          setTranslations(data.success_res.data);
        }
      } catch (error) { }
      setLoading(false);
    };

    getTranslationsFunc();
  }, []);

  const Content = ({ keyVal, missing, context }) => {
    const charLimit = 60;

    return (
      <>
        {keyVal.slice(0, charLimit)}
        {keyVal.length > charLimit ? "..." : ""}
        {missing && <span style={{ color: "red" }}> (Missing)</span>}
        {haveValue(context) && (
          <ul className="infodorpdown summarydropdum position-relative d-inline-block">
            <li>
              <button className="iconinfo">
                <MdInfoOutline />
              </button>{" "}
            </li>
            <ul className="tooltip">
              <p>{context}</p>
            </ul>
          </ul>
        )}
      </>
    );
  };

  const TranslationRow = ({ translation, onSave }) => {
    const [en, setEn] = useState(translation.en);
    const [es, setEs] = useState(translation.es);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
      setEn(translation.en);
      setEs(translation.es);
    }, [translation.en, translation.es]);

    const handleSave = async () => {
      if (en === translation.en && es === translation.es) {
        toast.error("Please change at least one value");
        return;
      }
      if (en === "" || es === "") {
        toast.error("Value can not empty");
        return;
      }
      setIsSaving(true);
      await onSave({
        key: translation.key,
        en,
        es,
      });
      setIsSaving(false);
    };

    return (
      <tr>
        <td width="200">
          <Content keyVal={translation.key} missing={translation.missing} context={translation.context} />
        </td>
        <td>
          <InputGroup className="input_table_header">
            <Form.Control
              type="text"
              value={en}
              onChange={(e) => setEn(e.target.value)}
            />
          </InputGroup>
        </td>
        <td>
          <InputGroup className="input_table_header">
            <Form.Control
              type="text"
              value={es}
              onChange={(e) => setEs(e.target.value)}
            />
          </InputGroup>
        </td>
        <td>
          <button
            type="button"
            className="btn-save"
            onClick={handleSave}
            disabled={isSaving}
          >
            Save
          </button>
        </td>
      </tr>
    );
  };

  const [generatingAiTranslations, setGeneratingAiTranslations] = useState(false);
  const [translatingProgress, setTranslatingProgress] = useState({
    done: 0,
    total: 0,
    progress: 0
  });

//   const generateTranslation = async (translation) => {
//     try {
//       const prompt = `
// Translate the following text to Spanish (es).
// Respond ONLY in valid JSON, no extra text, no explanations.

// {
//   "translation": "<your translation here>"
// }

// Text: "${translation.en}"
// `;

//       const result = await model.generateContent(prompt);
//       const rawText = result.response.text().trim();
//       const cleaned = rawText
//         .trim()
//         .replace(/^```json/, "")
//         .replace(/```$/, "");
//       let parsed;
//       try {
//         parsed = JSON.parse(cleaned);
//       } catch (e) {
//         console.error("Failed to parse translation:", rawText);
//         throw e;
//       }

//       translation.es = parsed.translation;
//       return translation;
//     } catch (err) {
//       console.error("Gemini translation failed:", err);
//       throw err;
//     }
//   };

  const generateTranslation = async (translation) => {
    try {
      const data = await translate({translation});
      return data?.result;
    } catch (err) {
      console.error("Gemini translation failed:", err);
      throw err;
    }
  };

  const generateAITranslations = async () => {
    setGeneratingAiTranslations(true);
    setTranslatingProgress({ done: 0, total: 0, percent: 0 });

    const limit = pLimit(5);
    const items = translations.filter(
      (t) => t.en !== "" && (t.es === "" || t.es === "-" || t.es === "--")
    );

    if (items.length === 0) {
      toast.error("No translations to fix.");
      setGeneratingAiTranslations(false);
      return;
    }

    setTranslatingProgress({ done: 0, total: items.length, percent: 0 });

    const translatedItems = [];

    const tasks = items.map((t) =>
      limit(async () => {
        try {
          const translationDone = await generateTranslation(t);
          translatedItems.push(translationDone);
        } finally {
          setTranslatingProgress((prev) => {
            const done = prev.done + 1;
            return {
              done,
              total: prev.total,
              percent: Math.round((done / prev.total) * 100),
            };
          });
        }
      })
    );

    const results = await Promise.allSettled(tasks);

    console.log(translatedItems);

    for (const item of translatedItems) {
      try {
        await updateTranslations({
          key: item.key,
          enValue: item.en,
          esValue: item.es,
        });
        setTranslations((prev) =>
          prev.map((t) =>
            t.key === item.key
              ? { ...t, en: item.en, es: item.es, missing: false }
              : t
          )
        );
      } catch (err) {
        console.error("Failed to update:", item, err);
        toast.error(`Failed to update ${item.key}`);
      }
    }

    setGeneratingAiTranslations(false);
    toast.success("AI Translation finished");
  };

  const handleSaveTranslation = async ({ key, en, es }) => {
    const response = await updateTranslations({
      key,
      enValue: en,
      esValue: es,
    });
    setTranslations((prev) =>
      prev.map((item) =>
        item.key === key
          ? {
              ...item,
              en,
              es,
              missing: false,
            }
          : item
      )
    );
    if (response?.data?.message) {
      toast.success(response.data.message);
    }
  };

  return (
    <>
      {loading ? <Loading /> : null}
      <div className="header_table d-flex justify-content-between align-items-center">
        <h1 className="mb-3">Translation</h1>
        <div className="btn-wrapper mb-3">
          <button
            type="button"
            className="btn-save"
            onClick={() => generateAITranslations()}
            disabled={generatingAiTranslations}
          >
            {
              generatingAiTranslations ? <>
                {
                  translatingProgress.done === translatingProgress.total ? <>
                    Saving..
                  </> : <>
                    Translating... {translatingProgress.done}/{translatingProgress.total} (
                    {translatingProgress.percent}%)
                  </>
                }
              </> : <>
                AI - Generate Translations
              </>
            }
          </button>
        </div>
      </div>
      <Table responsive hover>
        <thead className="patentiallanlord-admin-head">
          <th>Key</th>
          <th>English</th>
          <th>Spanish</th>
          <th>Actions</th>
        </thead>
        <tbody>
          {translations.map((translation) => (
            <TranslationRow
              key={translation.key}
              translation={translation}
              onSave={handleSaveTranslation}
            />
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default TranslationList;